<template>
  <div class="form-edit-page">
    <h2>Movimentações do Processo</h2>

    <!-- FORM DE ATO -->
    <div class="box">
      <h3>Novo Ato</h3>

      <div class="row">
        <div class="form-item">
          <label>Tipo de Ato</label>
          <select v-model="novo.tipo">
            <option>INTIMAÇÃO</option>
            <option>INFRAÇÃO</option>
            <option>MULTA</option>
            <option>ADVERTÊNCIA</option>
            <option>INTERDIÇÃO</option>
            <option>DESINTERDIÇÃO</option>
            <option>APREENSÃO</option>
            <option>DOAÇÃO</option>
          </select>
        </div>

        <div class="form-item">
          <label>Data</label>
          <input type="date" v-model="novo.data" />
        </div>
      </div>

      <div class="form-item">
        <label>Descrição</label>
        <textarea v-model="novo.descricao"></textarea>
      </div>

      <div class="row">
        <div class="form-item">
          <label>Valor (se multa)</label>
          <input v-model="novo.valor" />
        </div>

        <div class="form-item">
          <label>Prazo</label>
          <input type="date" v-model="novo.prazo" />
        </div>
      </div>

      <button @click="adicionar">Adicionar Ato</button>
    </div>

    <!-- LISTA -->
    <div class="box">
      <h3>Histórico do Processo</h3>

      <table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Valor</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, i) in lista" :key="i">
            <td>{{ item.data }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.valor }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'

const lista = ref([
  { data: '2026-03-01', tipo: 'INTIMAÇÃO', descricao: 'Adequação sanitária', valor: '' },
  { data: '2026-03-05', tipo: 'MULTA', descricao: 'Descumprimento', valor: 'R$ 1.000,00' }
])

const novo = reactive({
  tipo: 'INTIMAÇÃO',
  data: '',
  descricao: '',
  valor: '',
  prazo: ''
})

function adicionar() {
  lista.value.push({ ...novo })
}
</script>